export const mockBomWarnings = [
  {
    date: "2025-11-15",
    name: "Severe Thunderstorm Warning",
    timezone: "Australia/Sydney",
    severity: "severe",
    type: "thunderstorm",
    description:
      "Severe thunderstorms are likely to develop this afternoon, bringing heavy rainfall that may lead to flash flooding, damaging winds averaging 55 to 65 km/h with peak gusts around 100 km/h, and large hailstones. Storms are expected to affect the Sydney metropolitan area and surrounding regions from late afternoon through evening.",
    start_time: "2025-11-15T06:00:00Z",
    end_time: "2025-11-15T12:00:00Z",
  },
  {
    date: "2025-11-16",
    name: "Severe Weather Warning - Damaging Winds",
    timezone: "Australia/Sydney",
    severity: "severe",
    type: "wind",
    description:
      "Strong to damaging northwesterly winds averaging 55 to 65 km/h with peak gusts around 100 km/h are possible over lower elevations, including southern suburbs. Over elevated terrain above 1000 metres, damaging winds averaging 65 to 75 km/h with peak gusts in excess of 110 km/h are likely during the morning. Winds are forecast to ease below warning thresholds by afternoon.",
    start_time: "2025-11-15T20:00:00Z",
    end_time: "2025-11-16T06:00:00Z",
  },
  {
    date: "2025-11-17",
    name: "Flood Watch",
    timezone: "Australia/Melbourne",
    severity: "moderate",
    type: "flood",
    description:
      "Heavy rainfall is forecast for Friday, which may lead to riverine and flash flooding in low-lying areas. Rainfall totals of 50-100mm are expected across the catchment areas, with isolated falls up to 150mm possible. River levels may rise rapidly in response to the rainfall.",
    start_time: "2025-11-16T18:00:00Z",
    end_time: "2025-11-17T18:00:00Z",
  },
  {
    date: "2025-11-18",
    name: "Severe Thunderstorm Warning",
    timezone: "Australia/Brisbane",
    severity: "severe",
    type: "thunderstorm",
    description:
      "Severe thunderstorms are likely to develop this afternoon and evening, bringing heavy rainfall that may lead to flash flooding, damaging winds, and large hailstones. Storms are expected to move across the southeast Queensland region, affecting Brisbane and surrounding areas.",
    start_time: "2025-11-18T02:00:00Z",
    end_time: "2025-11-18T10:00:00Z",
  },
  {
    date: "2025-11-19",
    name: "Heatwave Warning",
    timezone: "Australia/Darwin",
    severity: "severe",
    type: "heatwave",
    description:
      "A prolonged period of high temperatures is expected over the next few days, with maximum temperatures reaching up to 35°C and minimum temperatures not falling below 28°C. The heatwave conditions are expected to persist for at least three consecutive days, increasing the risk of heat-related illness.",
    start_time: "2025-11-19T00:00:00Z",
    end_time: "2025-11-22T00:00:00Z",
  },
  {
    date: "2025-11-20",
    name: "Marine Wind Warning - Strong Wind",
    timezone: "Australia/Perth",
    severity: "moderate",
    type: "marine",
    description:
      "Strong winds of 26 knots or more are expected in coastal waters off Perth this afternoon and evening. Winds are forecast to increase to 30-35 knots with higher gusts possible. Boaters should exercise caution and consider postponing trips if possible.",
    start_time: "2025-11-19T22:00:00Z",
    end_time: "2025-11-20T10:00:00Z",
  },
  {
    date: "2025-11-21",
    name: "Severe Weather Warning - Damaging Winds and Heavy Rain",
    timezone: "Australia/Adelaide",
    severity: "severe",
    type: "wind",
    description:
      "A strong cold front is expected to bring damaging winds and heavy rainfall to the region. Winds averaging 60-70 km/h with peak gusts up to 110 km/h are likely, particularly over elevated areas. Rainfall totals of 30-50mm are expected, with isolated falls up to 80mm possible.",
    start_time: "2025-11-20T18:00:00Z",
    end_time: "2025-11-21T12:00:00Z",
  },
];
